import {
  EDIT_PROFILE_OPEN_DIALOG,
  EDIT_PROFILE_CLOSE_DIALOG,
} from 'actions/editProfile';

export const defaultState = {
  isEditProfileDialogOpen: false,
};

export default function editProfile(state = defaultState, action) {
  switch (action.type) {
    case EDIT_PROFILE_OPEN_DIALOG:
      return {
        ...state,
        isEditProfileDialogOpen: true,
      };
    case EDIT_PROFILE_CLOSE_DIALOG:
      return {
        ...state,
        isEditProfileDialogOpen: false,
      };
    default:
      return state;
  }
}
